import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { ContactApi } from "@app/services/apiServices/ContactApi";
import { HomeownerApi } from "@app/services/apiServices/HomeownerApi";
import { ContentApi } from "@app/services/apiServices/ContentApi";
import { VersionApi } from "@app/services/apiServices/VersionApi";
import { RegistrationApi } from "@app/services/apiServices/RegistrationApi";
import { CountryCallingCodeApi } from "@app/services/apiServices/CountryCallingCodeApi";
import { PropertyApi } from "@app/services/apiServices/PropertyApi";
import { PaymentApi } from "@app/services/apiServices/PaymentApi";
import { PaymentMethodApi } from "@app/services/apiServices/PaymentMethodApi";
import { PaymentScheduleApi } from "@app/services/apiServices/PaymentScheduleApi";
import { PaymentHistoryApi } from "@app/services/apiServices/PaymentHistoryApi";
import { StoresModule } from "@app/services/stores/stores.module";
import { PropertyGroupApi } from "@app/services/apiServices/PropertyGroupApi";
import { CalendarApi } from "@app/services/apiServices/CalendarApi";
import { SettingsApi } from "@app/services/apiServices/SettingsApi";
import { FTNIApi } from "@app/services/apiServices/FTNIApi";
import { ProductApi } from "@app/services/apiServices/ProductApi";

@NgModule({
    imports: [BrowserModule, StoresModule],
    exports: [],
    declarations: [],
    providers: [
        ContactApi,
        HomeownerApi,
        ContentApi,
        VersionApi,
        RegistrationApi,
        CountryCallingCodeApi,
        PaymentMethodApi,
        PropertyApi,
        PaymentApi,
        PaymentScheduleApi,
        PropertyGroupApi,
        PaymentHistoryApi,
        CalendarApi,
        SettingsApi,
        FTNIApi,
        ProductApi,
    ]
})

export class ApiServicesModule {}
